import {
  asset1,
  asset2,
  asset3,
  asset3SB,
  asset4,
  asset5,
  asset6,
  asset7,
  asset8,
  asset9,
  asset10,
  asset11,
  asset11Flip,
  asset12,
  asset12SB,
  asset13,
  asset13SB,
  asset14,
  asset14SB,
  asset15,
  lacesSB,
  placeholder,
} from './assets'
import {
  web1 as hweb1,
  web2 as hweb2,
  web3 as hweb3,
  web4 as hweb4,
  web5 as hweb5,
  web6 as hweb6,
} from './webs/h'
import {
  web1 as iweb1,
  web2 as iweb2,
  web3 as iweb3,
  web4 as iweb4,
  web5 as iweb5,
  web6 as iweb6,
} from './webs/i'
import {
  web1 as mbweb1,
  web2 as mbweb2,
  web3 as mbweb3,
  web4 as mbweb4,
} from './webs/mod-bar'
import {
  web1 as pweb1,
  web2 as pweb2,
  web3 as pweb3,
  web4 as pweb4,
  web5 as pweb5,
} from './webs/p'
import {
  web1 as spweb1,
  web2 as spweb2,
  web3 as spweb3,
  web4 as spweb4,
  web5 as spweb5,
} from './webs/single-post'
import { web1, web2, web3, web4, web5 } from './webs/snake-eyes'
import {
  web1 as tweb1,
  web2 as tweb2,
  web3 as tweb3,
  web4 as tweb4,
} from './webs/trap'
import {
  web1 as xweb1,
  web2 as xweb2,
  web3 as xweb3,
  web4 as xweb4,
  web5 as xweb5,
  web6 as xweb6,
  web7 as xweb7,
} from './webs/x'
import {
  web1 as msweb1,
  web2 as msweb2,
  web3 as msweb3,
  web4 as msweb4,
  web5 as msweb5,
  web6 as msweb6,
  web7 as msweb7,
  web8 as msweb8,
} from './webs/mod-single-post'

const assets = [
  { src: asset1, x: 0, y: 0, itemId: 101 },
  { src: asset2, x: 30.9507, y: 0.1371 },
  {
    src: asset3,
    x: 298.7157,
    y: 285.357,
    itemId: 102,
    excludeSportId: 'softball-ncaa',
  },
  {
    src: asset3SB,
    x: 298.7157,
    y: 285.357,
    itemId: 102,
    sportId: 'softball-ncaa',
  },
  { src: asset4, x: 53.6844, y: 1.416, itemId: 106, majorLayer: true },
  { src: asset5, x: 697.8057, y: 459.9441, itemId: 103 },
  { src: asset6, x: -100.5572, y: -100.9647, excludeSportId: 'softball-ncaa' },
  { src: asset7, x: 308.5335, y: 753.3531, itemId: 104, majorLayer: true },
  { src: asset8, x: 45.5628, y: 0, itemId: 109, majorLayer: true },
  { src: asset9, x: 285.5991, y: 730.7652, itemId: 108, majorLayer: true },
  {
    src: asset10,
    x: 717.1614,
    y: 602.8545,
    itemId: 114,
    blendMode: 'no-blend',
  },
  {
    src: asset11,
    x: 427.1154,
    y: 1071.8088,
    itemId: 116,
    blendMode: 'no-blend',
    hasFlippedAsset: true,
    flippedAssetIndex: 0,
    majorLayer: true,
  },
  {
    src: asset12,
    x: 836.0154,
    y: 544.2744,
    itemId: 110,
    excludeSportId: 'softball-ncaa',
  },
  {
    src: asset12SB,
    x: 837.8049,
    y: 911.859,
    itemId: 110,
    sportId: 'softball-ncaa',
  },
  {
    src: asset13,
    x: 831.7602,
    y: 494.1963,
    itemId: 112,
    excludeSportId: 'softball-ncaa',
  },
  {
    src: asset13SB,
    x: 834.1389,
    y: 907.9521,
    itemId: 112,
    sportId: 'softball-ncaa',
  },
  {
    src: asset14,
    x: 847.479,
    y: 928.644,
    itemId: 111,
    excludeSportId: 'softball-ncaa',
  },
  {
    src: asset14SB,
    x: 850.8237,
    y: 928.2861,
    itemId: 111,
    sportId: 'softball-ncaa',
  },
  {
    src: asset15,
    x: -23.9631,
    y: 55.3581,
    itemId: 107,
    excludeSportId: 'softball-ncaa',
  },
  {
    src: lacesSB,
    x: -24.036,
    y: 55.5264,
    itemId: 107,
    sportId: 'softball-ncaa',
  },
  { src: placeholder, x: 0, y: 0, itemId: 115 },
]

export const flippedAssets = [
  {
    src: asset11Flip,
    x: 360,
    y: 1040,
    itemId: 116,
    blendMode: 'no-blend',
    assetIndex: 11,
  },
]

export const webs = {
  h: [
    { src: hweb1, x: 564.3405, y: 10.6746, itemId: 105 },
    { src: hweb2, x: 588.8646, y: 53.7933, itemId: 114, blendMode: 'no-blend' },
    { src: hweb3, x: 740.127, y: 87.4557, itemId: 105 },
    { src: hweb4, x: 764.544, y: 100.5459, itemId: 114, blendMode: 'no-blend' },
    { src: hweb5, x: 747.8565, y: 83.0277, itemId: 115, blendMode: 'no-blend' },
    { src: hweb6, x: 564.8394, y: 37.0692, itemId: 107 },
  ],
  i: [
    { src: iweb1, x: 591.567, y: 11.3832, itemId: 105 },
    { src: iweb2, x: 636.9507, y: 64.6959, itemId: 114, blendMode: 'no-blend' },
    { src: iweb3, x: 780.0885, y: 109.4997, itemId: 105 },
    {
      src: iweb4,
      x: 783.7392,
      y: 112.8273,
      itemId: 114,
      blendMode: 'no-blend',
    },
    // { src: iweb5, x: 807.4506, y: 99.7845, itemId: 115, blendMode: 'no-blend' },
    { src: iweb6, x: 568.4664, y: 17.7849, itemId: 107 },
  ],
  'mod-bar': [
    { src: mbweb1, x: 563.825, y: 5.6928, itemId: 105 },
    {
      src: mbweb2,
      x: 587.3279,
      y: 54.438,
      itemId: 114,
      blendMode: 'no-blend',
    },
    // {
    //   src: mbweb3,
    //   x: 582.773,
    //   y: 62.8692,
    //   itemId: 115,
    //   blendMode: 'no-blend',
    // },
    { src: mbweb4, x: 583.0331, y: 4.7064, itemId: 107 },
  ],
  p: [
    { src: pweb1, x: 597.4458, y: 44.2212, itemId: 105 },
    { src: pweb2, x: 656, y: 133, itemId: 105, darken: 10 },
    { src: pweb3, x: 628.1715, y: 96, itemId: 114, blendMode: 'no-blend' },
    { src: pweb4, x: 879.2148, y: 448.293, itemId: 116, blendMode: 'no-blend' },
    { src: pweb5, x: 575.0907, y: 44.2242, itemId: 107 },
  ],
  'single-post': [
    { src: spweb1, x: 564.3405, y: 10.6746, itemId: 105 },
    {
      src: spweb2,
      x: 588.8646,
      y: 53.7933,
      itemId: 114,
      blendMode: 'no-blend',
    },
    { src: spweb3, x: 769.5405, y: 113.6541, itemId: 105 },
    {
      src: spweb4,
      x: 775.5399,
      y: 131.4636,
      itemId: 114,
      blendMode: 'no-blend',
    },
    { src: spweb5, x: 723.6093, y: 190.4487, itemId: 107 },
  ],
  'snake-eyes': [
    { src: web1, x: 604.1568, y: 16.5615, itemId: 105 },
    { src: web2, x: 642.3753, y: 75.7305, itemId: 114, blendMode: 'no-blend' },
    { src: web3, x: 735.4587, y: 87.9822, itemId: 115, blendMode: 'no-blend' },
    { src: web4, x: 870.7863, y: 215.5968, itemId: 116, blendMode: 'no-blend' },
    { src: web5, x: 569.0109, y: 32.7231, itemId: 107 },
  ],
  trap: [
    { src: tweb1, x: 760.3179, y: 68.7864, itemId: 105 },
    { src: tweb2, x: 772.9131, y: 81.8559, itemId: 114, blendMode: 'no-blend' },
    { src: tweb3, x: 574.0536, y: 31.0071, itemId: 107 },
    // {
    //   src: tweb4,
    //   x: 824.4072,
    //   y: 115.6428,
    //   itemId: 115,
    //   blendMode: 'no-blend',
    // },
  ],
  x: [
    { src: xweb1, x: 583.6311, y: 30.5313, itemId: 105 },
    { src: xweb2, x: 644.9892, y: 69.7707, itemId: 114, blendMode: 'no-blend' },
    { src: xweb3, x: 747.7779, y: 125.7531, itemId: 105 },
    {
      src: xweb4,
      x: 752.7714,
      y: 127.5147,
      itemId: 114,
      blendMode: 'no-blend',
    },
    {
      src: xweb5,
      x: 783.4326,
      y: 119.7975,
      itemId: 115,
      blendMode: 'no-blend',
    },
    { src: xweb6, x: 572.7867, y: 43.5618, itemId: 107 },
    {
      src: xweb7,
      x: 832.6482,
      y: 358.4178,
      itemId: 116,
      blendMode: 'no-blend',
    },
  ],
  'mod-single-post': [
    { src: msweb1, x: 588.0867, y: 17.2287, itemId: 105 },
    { src: msweb2, x: 642.2802, y: 58.467, itemId: 114, blendMode: 'no-blend' },
    { src: msweb3, x: 753.4107, y: 133.9827, itemId: 109 },
    { src: msweb4, x: 761.8008, y: 137.9541, itemId: 105 },
    {
      src: msweb5,
      x: 770.1534,
      y: 146.7132,
      itemId: 114,
      blendMode: 'no-blend',
    },
    {
      src: msweb6,
      x: 845.7648,
      y: 143.0586,
      itemId: 115,
      blendMode: 'no-blend',
    },
    { src: msweb7, x: 571.6008, y: 30.7332, itemId: 107 },
    { src: msweb8, x: 820.5693, y: 187.6254, itemId: 116 },
  ],
}

const data = {
  assets,
  flippedAssets,
  ...webs,
}

export default data
